document.addEventListener("variant:change", (e) => {
      if(!document.querySelector('quick-buy-drawer.show-close-cursor')){
        document.querySelector('.product-info .product-info__personalize').style.display = e.detail.variant.title === 'No' ? 'none' : 'block';
        document.querySelector('.product-info .product-info__personalize input').disabled = e.detail.variant.title === 'No' ? true : false;
      }
      if(document.querySelector('quick-buy-drawer.show-close-cursor')){
        document.querySelector('quick-buy-drawer .product-info__personalize').style.display = e.detail.variant.title === 'No' ? 'none' : 'block';
        document.querySelector('quick-buy-drawer .product-info__personalize input').disabled = e.detail.variant.title === 'No' ? true : false;
      }
});


document.addEventListener("change", (e) => {
      if(e.target.name === 'properties[File]'){
        var names = '';
    	for (var file in e.target.files){
    	  if(e.target.files[file].size){
    		names += e.target.files[file].name;
    	  }
    	}
    	if(names){
    	  e.target.closest('.product-info__personalize').querySelector('div').innerHTML = names;
    	}
      }
});


window.selectOrg = function selectOrg(elm) {
  var org = elm.querySelector('input').value;
  document.querySelector('[name="properties[Organization]"]').value = org;
  showOrdBio(org)
}

window.showOrdBio = function (org) {
  document.querySelectorAll('[data-orgbio]').forEach(elm => {
    elm.style.display = 'none';
  });
  document.querySelector('[data-orgbio="'+org+'"]').style.display = 'block';

  document.querySelectorAll('.featured-organization').forEach(elm => {
    elm.querySelector('input').checked = org === elm.querySelector('input').value;
   
  });
}